import { render, staticRenderFns } from "./standardReport.vue?vue&type=template&id=8be1596c&scoped=true&"
import script from "./standardReport.vue?vue&type=script&lang=js&"
export * from "./standardReport.vue?vue&type=script&lang=js&"
import style0 from "./standardReport.vue?vue&type=style&index=0&id=8be1596c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be1596c",
  null
  
)

export default component.exports